<template>
    <span style="float:right;font-size:smaller;">
      <span style="color:gray">Timezone: {{current_timezone}}</span>
      <span v-if="warning">
        <el-button @click="change_time">Change my timezone to {{browser_timezone}}</el-button>
      </span>
    </span>
</template>
<script>
    export default {
        props: ['current_timezone'],
        mounted() {
          this.browser_timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
          if (this.browser_timezone!==this.current_timezone) {
            this.warning = true
          }
        },
        data() {
            return {
                browser_timezone: null,
                warning: false,
            }
        },
        methods: {
          change_time() {
            console.log('clicked button')
            axios.post('/api/user/timezone', {
              timezone: this.browser_timezone
            }).then(response => {
              window.location.reload();
            }).catch(error => {
              console.log('oops problem setting timezone for user')
              console.log(error.response)
            })
          },
        }
    }
</script>